var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalida(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31,
    width: 31,
    height: 31,
    rx: 15.5,
    transform: "rotate(90 31 0)",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    width: 31,
    height: 31,
    rx: 15.5,
    transform: "rotate(90 31 0)",
    stroke: "#EFF3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3594 15.4922L8.35938 15.4922M12.3594 19.4922L8.35938 15.4922L12.3594 11.4922",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalida);
export default __webpack_public_path__ + "static/media/Salida.762be4e86e6828a0297f85dcfa88ff16.svg";
export { ForwardRef as ReactComponent };